import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

const API_URL = `${API_URL_COMMON}`;

class SubscriptionService {
  getBillingStatus(accountUrn) {
    return axios({
      method: "get",
      url: `${API_URL}/subscriptions/${accountUrn}/billing-status`,
      headers: authHeader(null, { account_urn: accountUrn }),
    });
  }

  getInvoices(subscriptionId, accountUrn) {
    return axios({
      method: "get",
      url: `${API_URL}/subscriptions/invoices/${subscriptionId}`,
      headers: authHeader(null, { account_urn: accountUrn }),
    });
  }

  createPortalSession(accountUrn) {
    return axios({
      method: "post",
      url: `${API_URL}/subscriptions/${accountUrn}/portal-session`,
      headers: authHeader(null, { account_urn: accountUrn }),
      data: { returnUrl: window.location.href },
    });
  }

  cancelSubscription(subscriptionId, accountUrn) {
    return axios({
      method: "delete",
      url: `${API_URL}/subscriptions/${subscriptionId}/cancel`,
      headers: authHeader(null, { account_urn: accountUrn }),
    });
  }
}

const subscriptionService = new SubscriptionService();

export default subscriptionService;
